import React from 'react';
import { CuratorTemplate, CuratorTemplateData } from '../../templates/CuratorTemplate';

// Reliable placeholder images using picsum.photos
const PLACEHOLDERS = {
    pfp: 'https://picsum.photos/seed/curator-pfp/400/400',
    dao1: 'https://picsum.photos/seed/dao1/100/100',
    dao2: 'https://picsum.photos/seed/dao2/100/100',
    art1: 'https://picsum.photos/seed/art1/500/500',
    art2: 'https://picsum.photos/seed/art2/500/600',
    art3: 'https://picsum.photos/seed/art3/600/500',
    art4: 'https://picsum.photos/seed/art4/500/500',
    art5: 'https://picsum.photos/seed/art5/500/700',
    art6: 'https://picsum.photos/seed/art6/500/500',
    art7: 'https://picsum.photos/seed/art7/600/600',
    art8: 'https://picsum.photos/seed/art8/500/500',
    artist: 'https://picsum.photos/seed/artist/200/200',
    artistWork: 'https://picsum.photos/seed/artistwork/600/400',
    host1: 'https://picsum.photos/seed/host1/100/100',
    host2: 'https://picsum.photos/seed/host2/100/100',
    host3: 'https://picsum.photos/seed/host3/100/100',
    host4: 'https://picsum.photos/seed/host4/100/100',
    bgArt: 'https://picsum.photos/seed/bgart/1200/800',
};

// Sample data demonstrating the Curator template
const sampleCuratorData: CuratorTemplateData = {
    identity: {
        name: 'DeeZe',
        handle: '@DeeZe',
        pfp: PLACEHOLDERS.pfp,
        tagline: 'Art enjoyer. Podcast host. Collecting the future.',
    },

    daoBadges: [
        {
            name: 'Flamingo DAO',
            logo: PLACEHOLDERS.dao1,
            link: 'https://flamingodao.xyz'
        },
        {
            name: 'Neon DAO',
            logo: PLACEHOLDERS.dao2,
            link: 'https://neondao.xyz'
        },
    ],

    collection: {
        title: 'The Collection',
        items: [
            {
                id: '1',
                image: PLACEHOLDERS.art1,
                title: 'CryptoPunk #3100',
                artist: 'CryptoPunks',
                link: '#'
            },
            {
                id: '2',
                image: PLACEHOLDERS.art2,
                title: 'Autoglyph #22',
                artist: 'Autoglyphs',
                link: '#'
            },
            {
                id: '3',
                image: PLACEHOLDERS.art3,
                title: 'Fidenza #313',
                artist: 'Tyler Hobbs',
                collection: 'Art Blocks',
                link: '#'
            },
            {
                id: '4',
                image: PLACEHOLDERS.art4,
                title: 'Ringers #879',
                artist: 'Dmitri Cherniak',
                collection: 'Art Blocks',
                link: '#'
            },
            {
                id: '5',
                image: PLACEHOLDERS.art5,
                title: 'Chromie Squiggle #7583',
                artist: 'Snowfro',
                collection: 'Art Blocks',
                link: '#'
            },
            {
                id: '6',
                image: PLACEHOLDERS.art6,
                title: 'Memories of Qilin',
                artist: 'Emily Xie',
                collection: 'Art Blocks',
                link: '#'
            },
            {
                id: '7',
                image: PLACEHOLDERS.art7,
                title: 'Gazers #42',
                artist: 'Matt Kane',
                link: '#'
            },
            {
                id: '8',
                image: PLACEHOLDERS.art8,
                title: 'The Currency #1234',
                artist: 'Damien Hirst',
                link: '#'
            },
        ],
    },

    artistSpotlight: {
        label: 'Currently vibing to...',
        artist: {
            name: 'Isaac "Drift" Wright',
            handle: '@daborafavedrifter',
            avatar: PLACEHOLDERS.artist,
            bio: 'Photographer capturing the human experience through bold, evocative imagery. His work explores identity, culture, and the streets of Brooklyn.',
        },
        featuredWork: {
            image: PLACEHOLDERS.artistWork,
            title: 'Untitled #47',
        },
        ctaLabel: 'Explore their collection',
        ctaLink: '#',
    },

    spaces: [
        {
            id: '1',
            title: 'Art Blocks Curation: What Makes a Curated Drop?',
            date: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
            coHosts: [
                { name: 'Snowfro', avatar: PLACEHOLDERS.host1, handle: 'artikiart' },
                { name: 'Tyler Hobbs', avatar: PLACEHOLDERS.host2, handle: 'tylerxhobbs' },
            ],
            spaceLink: '#',
        },
        {
            id: '2',
            title: 'Photography NFTs: The Next Wave',
            date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
            coHosts: [
                { name: 'Drift', avatar: PLACEHOLDERS.host3, handle: 'daborafavedrifter' },
            ],
            spaceLink: '#',
        },
        {
            id: '3',
            title: 'We Do A Little - Episode 47',
            date: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000),
            coHosts: [
                { name: 'Andy', avatar: PLACEHOLDERS.host4, handle: 'andy' },
            ],
            spaceLink: '#',
        },
    ],

    contentLinks: [
        {
            type: 'newsletter',
            title: "DeeZe's Diary",
            description: 'Weekly art picks and thoughts',
            icon: '📧',
            cta: 'Subscribe',
            link: '#',
            stats: '2,400 readers',
        },
        {
            type: 'podcast',
            title: 'We Do A Little',
            description: 'NFT conversations with DeeZe & Andy',
            icon: '🎙️',
            cta: 'Listen',
            link: '#',
            stats: '50+ episodes',
        },
        {
            type: 'discord',
            title: 'The Gallery',
            description: 'Art collectors community',
            icon: '💬',
            cta: 'Join',
            link: '#',
            stats: '1,200 members',
        },
    ],

    social: {
        twitter: 'https://twitter.com/DeeZe',
        discord: 'https://discord.gg/thegallery',
    },

    theme: {
        backgroundArt: PLACEHOLDERS.bgArt,
    },
};

const CuratorDemo: React.FC = () => {
    return <CuratorTemplate data={sampleCuratorData} />;
};

export default CuratorDemo;
